import { Observable, Subject } from "rxjs";
import { IRefreshService } from "./Interfaces/IRefreshService";


export class RefreshService implements IRefreshService {

    _auctionsUpdated: Subject<void> = new Subject<void>();
    _myAuctionsUpdated: Subject<void> = new Subject<void>();
    _auctionAdminGridUpdated: Subject<void> = new Subject<void>();
    _appointmentsUpdated: Subject<void> = new Subject<void>();
    _refreshCaseList: Subject<void> = new Subject<void>();
    _casesToRefresh: Subject<number[]> = new Subject<number[]>();
    _appointmentsToRefresh: Subject<number[]> = new Subject<number[]>();
    _refreshOrderList: Subject<void> = new Subject<void>();
    _ordersToRefresh: Subject<number[]> = new Subject<number[]>();

    public RefreshAuctions$(): Observable<void> {
        return this._auctionsUpdated.asObservable();
    }
    public RefreshMyAuctions$(): Observable<void> {
        return this._myAuctionsUpdated.asObservable();
    }
    public RefreshMyAuctions(): void {
        this._myAuctionsUpdated.next();
    }
    public RefreshAppointments$(): Observable<void> {
        return this._appointmentsUpdated.asObservable();
    }
    public RefreshAuctions(): void {
        this._auctionsUpdated.next();
    }
    public RefreshAppointments(): void {
        this._appointmentsUpdated.next();
    }

    public RefreshAdminAuctionGrid(): void {
        this._auctionAdminGridUpdated.next();
    }

    public RefreshAdminAuctionGrid$(): Observable<void> {
        return this._auctionAdminGridUpdated.asObservable();
    }

    public RefreshCaseList(): void {
        this._refreshCaseList.next();
    }

    public RefreshCaseList$(): Observable<void> {
        return this._refreshCaseList.asObservable();
    }

    public CasesToRefresh$(): Observable<number[]> {
        return this._casesToRefresh.asObservable();
    }

    public AppointmentsToRefresh$(): Observable<number[]> {
        return this._appointmentsToRefresh.asObservable();
    }

    public SetCasesToRefresh(caseIds: number[]): void {
        this._casesToRefresh.next(caseIds);
    }    

    public SetAppointmentsToRefresh(appointmentIds: number[]): void {
        this._appointmentsToRefresh.next(appointmentIds);
    }    

    public RefreshOrderList$(): Observable<void> {
        return this._refreshOrderList.asObservable();
    }
    
    public RefreshOrderList(): void {
        this._refreshOrderList.next();
    }

    public OrdersToRefresh$(): Observable<number[]> {
        return this._ordersToRefresh.asObservable();
    }

    public SetOrdersToRefresh(orderIds: number[]): void {
        this._ordersToRefresh.next(orderIds);
    }
}